export default __webpack_public_path__ + "static/media/integrity-logo.5e0c811b.svg";